import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const KeygeekY3 = () => (
  <ArticleWrapper articleId="keygeek_y3">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Keygeek Y3</h1>
      {/* Add your Keygeek Y3 article content here */}
      <p>This is a placeholder article for the Keygeek Y3 switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default KeygeekY3;
